import { combineReducers } from 'redux';

import {
    COMPANY_LOADING,
    COMPANY_LOADED,
    COMPANY_UPDATED,
    DEBTS_PARALIZE_LOADING,
    DEBTS_PARALIZED,
    DEBTS_START_LOADING,
    DEBTS_STARTED_CHARGES,
    BUSINESS_AREAS_LOADING,
    BUSINESS_AREAS_LOADED,
    LOAD_BANK_STATEMENT_REQUEST,
    LOAD_BANK_STATEMENT_SUCCESS,
    LOAD_BANK_STATEMENT_ERROR,
} from 'modules/company/actions/company.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';


const isLoading = (state = false, action) => {
    switch (action.type) {
        case LOAD_BANK_STATEMENT_REQUEST:
            return true;
        case LOAD_BANK_STATEMENT_SUCCESS:
        case LOAD_BANK_STATEMENT_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const loadingCompany = (state = false, action) => {
    switch (action.type) {
        case COMPANY_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const company = (state = null, action) => {
    switch (action.type) {
        case COMPANY_LOADED:
            return action.payload;
        case COMPANY_UPDATED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export const loadingParalizeDebts = (state = false, action) => {
    switch (action.type) {
        case DEBTS_PARALIZE_LOADING:
            return action.payload;
        case DEBTS_PARALIZED:
            return false;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const loadingStartDebts = (state = false, action) => {
    switch (action.type) {
        case DEBTS_START_LOADING:
            return action.payload;
        case DEBTS_STARTED_CHARGES:
            return false;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const loadingBusinessAreas = (state = false, action) => {
    switch (action.type) {
        case BUSINESS_AREAS_LOADING:
            return action.payload;
        case BUSINESS_AREAS_LOADED:
            return false;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const businessAreas = (state = null, action) => {
    switch (action.type) {
        case BUSINESS_AREAS_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const processBankStatement = (payload) => {
    const { items } = payload;
    let postionAdd = 0
    /* eslint no-restricted-syntax:0 */
    for (const [key, value] of Object.entries(items)) {
        if(value.type === 2){
            const position = parseInt(key, 10) + 1 + postionAdd;
            postionAdd += 1;
            console.log(position);
            items.splice(position, 0, {
                comission_amount: null,
                comission_percentage: null,
                created_at: value.created_at,
                fk_company: value.fk_company,
                fk_deal: null,
                liquid_amount: value.tax,
                paid_amount: null,
                reference: null,
                tax: value.tax,
                type: 3
            });
        }
    }
    return payload;
};

const bankStatement = (state = {}, action) => {
    switch (action.type) {
        case LOAD_BANK_STATEMENT_SUCCESS:
            return processBankStatement(action.payload);
        case AUTH_LOGOUT:
            return {};
        default:
            return state;
    }
};




export default combineReducers({
    loadingCompany,
    company,
    loadingParalizeDebts,
    loadingStartDebts,
    loadingBusinessAreas,
    businessAreas,
    bankStatement,
    isLoading,
});
